module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Frenkendorf-78c891e2dc077cd225419ea50228cc8d.png";